<template>
	<div>
		<goal-status-report mine-only />
	</div>
</template>

<script>
	// Reports
	import GoalStatusReport from '@/components/reports/GoalStatusReport';

	export default {
		components: {
			GoalStatusReport
		},
		data() {
			return {};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'My Goals');
		}
	};
</script>

<style></style>
